export const DEFAULT_DATA = Object.freeze({
  game_id: 0,
  track: "Standard",
  p_faction: null,
  p_mat: null,
  p_score: null,
  p_win: false,
  a_faction: null,
  a_level: 2,
  a_score: null,
  airship_active: 0,
  airship_passive: 0,
  resolution: 0,
  tokens: 0,
  bonus: 0,
  combats: false,
  location: "normal",
});
